import { useState, useEffect, useRef } from "react";
import { Typewriter } from "react-simple-typewriter";
import hero from "../../assets/Flatline.svg";
import styles from "./Hero.module.css";
import { constants } from "../../utils/constants";
import useIsInViewport from "../../utils/hooks/useIsInViewport";

function Hero() {
  const sectionRef = useRef();
  const isInViewport = useIsInViewport(sectionRef);
  const [activeNav, setActiveNav] = useState(false);
  useEffect(() => {
    function handleScroll() {
      window.scrollY > 100 ? setActiveNav(true) : setActiveNav(false);
    }
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <section
      className={
        activeNav ? `${styles.hero} ${styles.heroActive}` : styles.hero
      }
      id="home"
      ref={sectionRef}
    >
      {/*       <div className={styles.boxP}>ss</div>
      <div className={styles.boxS}>f</div> */}
      {/*       <div className="container f_flex top">
       */}{" "}
      <div className={styles.heroContainer}>
        <div className={styles.heroLeft}>
          <h1>
            <span>Jonathan Mendoza</span>
          </h1>

          <h2>
            <Typewriter
              words={[
                " Frontend Developer",
                " Backend Developer",
                " Full Stack Developer",
              ]}
              cursor
              cursorStyle="|"
              typeSpeed={90}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </h2>
          <h3>
            I design and develop complete web applications using Frontend and
            Backend technologies. I have experience in HTML, CSS, JavaScript,
            React, Angular, Node.js, MySQL, MongoDB and Firebase.
            {/* Experiencia en Creación, prototipado y desarrollo de
            productos digitales innovadores centrados en el usuario. */}
          </h3>
          <div className={styles.socialSkills}>
            <div className={`col_1 ${isInViewport ? styles.slideIn : ""}`}>
              <h5>I&#39;m learning</h5>
              <figure className={styles.skillBtn}>
                <img
                  width="50px"
                  height="50px"
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg"
                  alt="react"
                />
              </figure>
              <figure className={styles.skillBtn}>
                <img
                  width="50px"
                  height="50px"
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg"
                  alt="NodeJs"
                />
              </figure>
              <figure className={styles.skillBtn}>
                <img
                  width="50px"
                  height="50px"
                  src="https://a0.awsstatic.com/libra-css/images/logos/aws_logo_smile_1200x630.png"
                  alt="Js"
                />
              </figure>
            </div>
          </div>
        </div>
        <div className={styles.heroRight}>
          <div className={styles.rightImg}>
            <img
              width="300px"
              height="400px"
              src={hero}
              alt="hero"
              className={styles.img}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
